// extracted by mini-css-extract-plugin
export var connectionButton = "_c0-1";
export var connectionButtonFloating = "_c0-2";
export var connectionContainer = "_c0-0";
export var rightPanel = "_c0-6";
export var stepCard = "_c0-3";
export var stepCardSubtitle = "_c0-5";
export var stepCardText = "_c0-4";